

<label class="switch switch-text switch-outline-success form-control-label me-2">
  @if (passedValue) {
    <input [disabled]="!toggleAllowed" type="checkbox" (change)="onSwitch($event);" class="switch-input form-check-input" value="on" checked>
  }
  @if (!passedValue) {
    <input [disabled]="!toggleAllowed" type="checkbox" (change)="onSwitch($event);" class="switch-input form-check-input" value="on">
  }
  <span class="switch-label" data-on="Ja" data-off="Nee"></span>
  <span class="switch-handle"></span>
</label>
